import Vue from 'vue'

export const Select2Test = Vue.component(
  'Select2Test',
  require('_/components/Test/Select2Test/Select2Test.vue').default
)

export const BootstrapSwitch = Vue.component(
  'BootstrapSwitch',
  require('_/components/Test/BootstrapSwitch/BootstrapSwitch.vue').default
)

export const InputText = Vue.component(
  'InputText',
  require('_/components/Test/InputText/InputText.vue').default
)

export const Password = Vue.component(
  'InputText',
  require('_/components/Test/Password/Password.vue').default
)

export const DateTimePicker = Vue.component(
  'DateTimePicker',
  require('_/components/Test/DateTimePicker/DateTimePicker.vue').default
)

export const RichText = Vue.component(
  'RichText',
  require('_/components/Test/RichText/RichText.vue').default
)

export const Textarea = Vue.component(
  'Textarea',
  require('_/components/Test/Textarea/Textarea.vue').default
)

export const ColorPicker = Vue.component(
  'ColorPicker',
  require('_/components/Test/ColorPicker/ColorPicker.vue').default
)

export const Location = Vue.component(
  'Location',
  require('_/components/Test/Location/Location.vue').default
)

export const Radio = Vue.component(
  'Radio',
  require('_/components/Test/Radio/Radio.vue').default
)

export const Checkbox = Vue.component(
  'Checkbox',
  require('_/components/Test/Checkbox/Checkbox.vue').default
)
